export default __webpack_public_path__ + "static/media/Hero.689d5f6c.jpg";